// Angular
import { Injectable, inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// RxJs & Lodash
import { Observable } from "rxjs";
import { catchError } from 'rxjs/operators';
// Utils
import { GlobalErrorHandler, HttpUtilsService } from '@core/utils';
// Constants
import { API_URL } from '@constants';
// Models
import { ICreateCartPayload, ICreateInfracomSessionPayload } from "../models";

@Injectable({
    providedIn: 'root'
})
export class ActiveCallCartService {

    // Private
    private readonly httpUtilsService = inject(HttpUtilsService);
    private readonly globalErrorHandler = inject(GlobalErrorHandler);
    private readonly http = inject(HttpClient);


    /**
     * Django - Create/Update Cart
     * @param {ICreateCartPayload} payload
     * @returns {Observable<any>}
     * @memberof ActiveCallCartService
     */
    public createOrUpdateCartDjango(payload: ICreateCartPayload): Observable<any> {
        return this.httpUtilsService
            .postData(API_URL.CREATE_CART_URL, payload, null, { accept: 'application/json' })
            .pipe(
                catchError((error: any) => this.globalErrorHandler.handleError('create-or-update-cart-django', error, true))
            );
    }

    /**
     * Create/Update Cart
     * @param {ICreateCartPayload} payload
     * @returns {Observable<any>}
     * @memberof ActiveCallCartService
     */
    public createOrUpdateCart(payload: ICreateCartPayload): Observable<any> {
        return this.httpUtilsService
            .postData(API_URL.CART_V2_URL, payload, null, { 'prefer': 'params=single-object' })
            .pipe(
                catchError((error: any) => this.globalErrorHandler.handleError('create-or-update-cart', error, true))
            );
    }

    /**
     * Create Active Cart Phone Session OR 
     * Infracom session
     * @param {ICreateInfracomSessionPayload} payload
     * @returns {Observable<any>}
     * @memberof ActiveCallCartService
     */
    public createInfracomSession(payload: ICreateInfracomSessionPayload): Observable<any> {
        return this.httpUtilsService
            .postData(API_URL.ACTIVE_CART_CALL_SESSION_URL, payload, null, { 'prefer': 'return=representation', 'accept': 'application/vnd.pgrst.object+json', 'content-profile': 'weblink' })
            .pipe(
                catchError((error: any) => this.globalErrorHandler.handleError('create-new-infracom-session', error, true))
            );
    }

    /**
     *Get Current Infracom Session
     * @param {*} params
     * @returns {Observable<any>}
     * @memberof ActiveCallCartService
     */
    public getCurrentInfracomSession(params: any): Observable<any> {
        return this.httpUtilsService
            .getData(API_URL.ACTIVE_CART_CALL_SESSION_URL, params, { 'prefer': 'return=representation', 'accept-profile': 'weblink' })
            .pipe(
                catchError((error: any) => this.globalErrorHandler.handleError('get-current-infracom-session', error, true))
            );
    }

    /**
     * Get Cart Details from Server
     * @param {string} cartKey
     * @returns {Observable<any>}
     * @memberof ActiveCallCartService
     */
    public getCartFromServer(cartKey: string): Observable<any> {
        return this.http.get(`${API_URL.CART_V1_URL}${cartKey}`)
            .pipe(
                catchError((error: any) => this.globalErrorHandler.handleError('get-cart-data-from-server', error, true))
            );
    }
}